<script setup lang="ts">
  import { computed } from 'vue';
  import type { Brand, ProductCategory } from '@storefront/types';

  interface MetaSource {
    ean: string | null;
    sku: string | null;
    mpn: string | null;
  }

  interface Props {
    variant: MetaSource
    brand?: Brand | null,
    category?: ProductCategory | null,
  }

  const props = defineProps<Props>();

  const ean = computed(() => props.variant.ean);
  const sku = computed(() => props.variant.sku);
  const mpn = computed(() => props.variant.mpn);
</script>
<template>
  <div class="meta">
    <dl class="wrapper">
      <div v-if="brand" class="info brand">
        <dt class="property">
          {{ $t('SHOP.PRODUCT.LABEL.PROPERTY_BRAND')}}
        </dt>
        <dd class="value">
          <RouterLink :href="$route('web.product.index', { brands: [brand.id] })">
            {{ brand.name }}
          </RouterLink>
        </dd>
      </div>
      <div v-if="category" class="info category">
        <dt class="property">
          {{ $t('SHOP.PRODUCT.LABEL.PROPERTY_CATEGORY') }}
        </dt>
        <dd class="value">
          <RouterLink :href="$route('web.product.category', { category })">
            {{ category.title }}
          </RouterLink>
        </dd>
      </div>
      <div v-if="ean" class="info ean">
        <dt class="property">
          {{ $t('SHOP.PRODUCT.LABEL.PROPERTY_EAN') }}
        </dt>
        <dd class="value">
          {{ ean }}
        </dd>
      </div>
      <div v-if="sku" class="info sku">
        <dt class="property">
          {{ $t('SHOP.PRODUCT.LABEL.PROPERTY_SKU') }}
        </dt>
        <dd class="value">
          {{ sku }}
        </dd>
      </div>
      <div v-if="mpn" class="info mpn">
        <dt class="property">
          {{ $t('SHOP.PRODUCT.LABEL.PROPERTY_MPN') }}
        </dt>
        <dd class="value">
          {{ mpn }}
        </dd>
      </div>
    </dl>
  </div>
</template>
<style scoped lang="scss">
  .meta .wrapper {
    display: flex;
    flex-direction: column;

    a {
      text-decoration: underline;
      text-decoration-color: transparent;
      transition: text-decoration-color 0.2s ease-out;
    }

    @media(hover: hover) {
      a:hover {
        text-decoration-color: var(--primary-color);
      }
    }


    .info {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
      font-size: 0.875rem;
      line-height: 1.5;

      .property {
        font-weight: var(--font-weight-semi);
      }
    }
  }
</style>
